export default __webpack_public_path__ + "static/media/untitled_design_13.f791306d.png";